import React from "react";

const PaymentCancel = () => {
  return (
    <div className="payment-failed-content--detail page-height">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        fill="#a82323"
        className="bi bi-exclamation-circle"
        viewBox="0 0 16 16"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
      </svg>

      <h4 className="payment-title-cancel">Payment Cancelled</h4>

      <p className="cancelled-title-desc">
        It looks like you chose not to complete the payment process.
      </p>
      <p>No amount has been deducted from your account.</p>
    </div>
  );
};

export default PaymentCancel;
